export enum CampaignSetupAgentToolName {
  DeleteCard = 'deleteCard',
  GetCardDetails = 'getCardDetails',
  GetCardDetailsFromRedux = 'getCardDetailsFromReduxTool',
  GetConditionSignal = 'getConditionSignal',
  AddOrUpdateConditionCard = 'addOrUpdateConditionCard',
  GetCreatives = 'getCreatives',
  GetContentFeeds = 'getContentFeeds',
  GetContentSignals = 'getContentSignals',
  GetContentFeedColumns = 'getContentFeedColumns',
  GetContentSets = 'getContentSets',
  CardsConnection = 'cardsConnection',
  MatchStrategy = 'matchStrategy',
  GetLocationFeeds = 'getLocationFeeds',
  GetLocationSets = 'getLocationSets',
  GetProductMatchingSignal = 'getProductMatchingSignal',
  GetProductFeedColumns = 'getProductFeedColumns',
  AutoArrangeCards = 'autoArrangeCards',
  SearchFeedValues = 'searchFeedValues',
  AskAboutObjects = 'askAboutObjects',
  VerifyCampaignPath = 'verifyCampaignPath',
  ListSelectionStrategies = 'listSelectionStrategies',
  GetSelectionStrategyDetails = 'getSelectionStrategyDetails',
  NavigateToCampaignsLibrary = 'navigateToCampaignsLibrary',
  DuplicateSubtree = 'duplicateSubtree',
  DuplicateCard = 'duplicateCard',
}
